/* global vm */

const state = {
  isReady: false,
  production_id: null,
  screen_id: null,
  verification_key: null,
};

const actions = {
  setupLive({ rootState }) {
    const { id } = rootState.production.production;
    vm.$socket.emit('connectLive', { production_id: id });
  },

  socket_preview({ commit }, payload) {
    commit('UPDATE_LIVE', payload);
  },

  resetLive({ commit }) {
    commit('RESET_LIVE');
  },
};

const mutations = {
  /* eslint-disable no-shadow, no-param-reassign */

  RESET_LIVE(state) {
    state.isReady = false;
  },

  UPDATE_LIVE(state, payload) {
    state.production_id = payload.production_id;
    state.screen_id = payload.screen_id;
    state.verification_key = payload.verification_key;

    if (state.production_id && state.screen_id && state.verification_key) {
      state.isReady = true;
    }
  },
};

const getters = {
  liveConnectionReady(state) {
    return state.isReady;
  },

  liveUrl(state) {
    return state.isReady ? `${process.env.TAGBOARD_LIVE_URL}/live/${state.production_id}?screen_id=${state.screen_id}&verification_key=${state.verification_key}` : '';
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
